<template>
  <ContentSection permissions="Feedback and Complaint Settlement" :detail="settlementIssue">
    <template #initial-form>
      <div>
        <div
          v-permissions="'View All Feedback and Complaint Settlements,View Feedback and Complaint Settlements,Create Feedback and Complaint Settlement,Edit Feedback and Complaint Settlement'"
          v-if="!settlementIssue || (settlementIssue && settlementIssue?.status?.value === 'pending')"
          class="white-box mm15 p30 mb-3" style="min-height: auto;">
          <div class="popup-item p-0">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex flex-row justify-content-between align-items-center mb-4">
                  <div class="ft-16 font-bold">Settlement (Tech Sales Supp)</div>
                </div>
                <div class="d-flex flex-column gap-2">
                  <div v-if="settlementIssue"
                    class=" btn-border-green border-dashed rounded w-100 p-3 d-flex align-items-center justify-content-between">
                    <div class="ft-14 d-flex flex-row justify-content-between align-items-center">
                      <img :src="IconCheck" alt="check" style="margin-right: 8px;" />
                      <span>Settlement Form</span>
                    </div>
                    <button class="btn btn-see ft-14"
                      @click="$router.push(`/feedback/${$route.params.id}/settlement-issue/edit`)">
                      Edit
                    </button>
                  </div>
                  <router-link v-else :to="`/feedback/${$route.params.id}/settlement-issue`"
                    class="btn btn-border-orange border-dashed w-100">Settlement Form</router-link>
                  <button @click="onSubmit" :disabled="!settlementIssue" type="button"
                    class="btn btn-orange w-100">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #submitted-form="{ toggleCollapse, isCollapse, openModal, closeModal, modal }">
      <div v-if="settlementIssue && !['pending'].includes(settlementIssue?.status?.value)"
        class="white-box mm15 p30 mb-3" style="min-height: auto;">
        <div class="popup-item p-0">
          <div class="row">
            <div class="col-sm-12">
              <div class="d-flex flex-row justify-content-between align-items-center">
                <div class="ft-16 font-bold">Settlement (Tech Sales Supp)</div>
                <button @click="toggleCollapse" class="btn btn-transparent" :class="{ 'rotate': isCollapse }"><span
                    class="icon-ico-arrow-down"></span></button>
              </div>
              <div class="card-content" :class="{ 'show': isCollapse }">
                <div class="popup-item">
                  <div class="row">
                    <div class="col-sm-12 col-12">
                      <div class="grey">Settlement</div>
                      <span>{{ settlementIssue?.settlement }}</span>
                    </div>
                  </div>
                </div>
                <button @click="openModal('detail')" class="btn btn-see ft-14 mt-3">
                  Show detail
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Detail Modal -->
        <div class="popup-wrapper" :class="{ 'showing': modal.detail }">
          <div class="popup-card p25">
            <div class="d-flex justify-content-between align-items-center">
              <div class="font-bold">Settlement (Tech Sales Supp)</div>
              <button @click="closeModal('detail')" class="btn btn-for-close"><span
                  class="icon-ico-close"></span></button>
            </div>
            <div class="inner-land" style="max-height: 80vh; overflow-y: auto; overflow-x: hidden;">
              <div class="popup-item">
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <div class="grey">No. CRM</div>
                    <span>{{ settlementIssue?.no_crm }}</span>
                  </div>
                  <div class="col-sm-6 col-6">
                    <div class="grey">Date</div>
                    <span>{{ settlementIssue?.date ? moment(settlementIssue?.date, 'YYYY-MM-DD').format('DD-MM-YYYY') :
                      '-'
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="popup-item">
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <div class="grey">Customer Name</div>
                    <span>{{ settlementIssue?.customer_name }}</span>
                  </div>
                  <div class="col-sm-6 col-6">
                    <div class="grey">Contact Person</div>
                    <span>{{ settlementIssue?.contact_person}}</span>
                  </div>
                </div>
              </div>
              <div class="popup-item">
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <div class="grey">Subject</div>
                    <span>{{ settlementIssue?.subject }}</span>
                  </div>
                </div>
              </div>
              <div class="popup-item wb">
                <div class="row">
                  <div class="col-sm-12 col-12">
                    <div class="grey">Problem Cause</div>
                    <span>{{ settlementIssue?.problem_cause }}</span>
                  </div>
                </div>
              </div>
              <h6 class="mt-3 ft-14 font-bold">Follow Up</h6>
              <div class="popup-item">
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <div class="grey">Taken by</div>
                    <span>{{ settlementIssue?.taken_by?.name }}</span>
                  </div>
                  <div class="col-sm-6 col-6">
                    <div class="grey">Date</div>
                    <span>{{ settlementIssue?.taken_by_date }}</span>
                  </div>
                </div>
              </div>
              <div class="popup-item">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="grey">Corrective Action</div>
                    <span>{{ settlementIssue?.corrective_action }}</span>
                  </div>
                </div>
              </div>
              <div class="popup-item wb">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="grey">Preventive Action</div>
                    <span>{{ settlementIssue?.preventive_action }}</span>
                  </div>
                </div>
              </div>
              <div class="popup-item wb">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="grey">Settlement</div>
                    <span>{{ settlementIssue?.settlement }}</span>
                  </div>
                </div>
              </div>
              <div class="popup-item">
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <div class="grey">Status</div>
                    <span>{{ settlementIssue?.follow_up_status }}</span>
                  </div>
                  <div class="col-sm-6 col-6">
                    <div class="grey">Date</div>
                    <span>{{ settlementIssue?.follow_up_date }}</span>
                  </div>
                </div>
              </div>
              <div class="popup-item">
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <div class="grey">Prepared by</div>
                    <span>{{ settlementIssue?.prepared_by?.name }}</span>
                  </div>
                  <div class="col-sm-6 col-6">
                    <div class="grey">Checked by</div>
                    <span>{{ settlementIssue?.checked_by?.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #action-form="{ openModal, closeModal, modal }">
      <div>
        <div
          v-permissions="'Revision Feedback and Complaint Settlement,Approve Feedback and Complaint Settlement'"
          v-if="['waiting_approval', 'approved_by_tech_mkt_support_mgr', 'approved_by_mkt_sales_gm'].includes(settlementIssue?.status?.value)"
          class="white-box mm15 p30 mb-3" style="min-height: auto;">
          <div class="popup-item p-0">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex flex-row justify-content-between align-items-center">
                  <div class="ft-16 font-bold">Settlement ({{ currentRoleProgress }})</div>
                </div>
                <div class="popup-item wb">
                  <div class="row mt-2">
                    <div v-permissions="'Revision Feedback and Complaint Settlement'" class="col-sm-6">
                      <button @click="openModal('revision'); $refs.formRevision.form.revision = ''"
                        class="btn btn-border-orange w-100">Need Revision</button>
                    </div>
                    <div v-permissions="'Approve Feedback and Complaint Settlement'" class="col-sm-6">
                      <button @click="openModal('approve')" class="btn btn-orange w-100">Approve</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Form Revision Modal -->
          <div class="popup-wrapper" :class="{ 'showing': modal.revision }">
            <div class="popup-card p25">
              <div class="d-flex justify-content-between align-items-center">
                <div class="font-bold">Need Revision</div>
                <button type="button" @click="closeModal('revision');" class="btn btn-for-close"><span
                    class="icon-ico-close"></span></button>
              </div>
              <div class="inner-land">
                <div class="popup-item">
                  <div class="row gap-2">
                    <FormRevision ref="formRevision" @close-modal="closeModal('revision')"
                      @on-revision="value => handleRevision(value, closeModal('revision'))" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Form Approve Modal (hook) -->
          <div class="popup-wrapper" :class="{ 'showing': modal.approve }">
            <div class="popup-card p25" style="max-width: 366px;">
              <div class="d-flex justify-content-between align-items-center">
                <div class="font-bold">Approve</div>
              </div>
              <div class="inner-land mt-2">
                <div class="popup-item p-0">
                  <div>Are you sure to approve this request?</div>
                  <div class="row mt-3">
                    <div class="col-sm-6">
                      <button @click="closeModal('approve')" type="button" class="btn btn-orange w-100">Back</button>
                    </div>
                    <div class="col-sm-6">
                      <button @click="handleApprove(closeModal('approve'))" type="button"
                        class="btn btn-border-orange w-100">Send</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #cta-edit-form>
      <div>
        <button v-permissions="'Create Feedback and Complaint Settlement,Edit Feedback and Complaint Settlement'"
          @click="$router.push(`/feedback/${$route.params.id}/settlement-issue/edit`)"
          class="btn btn-orange mm15 w-100">Edit Settlement Form</button>
      </div>
    </template>
  </ContentSection>
</template>
<script>
import FormRevision from '../form-revision.vue'
import IconCheck from '@/assets/icons/check.svg';
import axios from '@/axios';
import { showErrorMessage } from '@/utils';
import ContentSection from '../Content';
import moment from 'moment';
export default {
  name: "FNCDetailSettlementIssue",
  components: {
    ContentSection,
    FormRevision
  },
  data() {
    return {
      IconCheck,
      moment,
      form: {
        revision: ''
      }
    }
  },
  async created() {
    this.$store.dispatch('getDetailFeedbackComplaintSettlementIssue', this.$route.params.id)
  },
  methods: {
    async onSubmit() {
      try {
        const { data: responseData, status } = await axios.put(`/fnc-settlements/${this.$route.params.id}`, {
          status: "waiting_approval"
        });
        if (status === 200 && responseData?.data) {
          // refresh internal issue detail
          this.refreshData()
        }
      } catch (error) {
        showErrorMessage(error);
      }
    },
    async handleRevision(revision, callback) {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        await axios.put(`/fnc-settlements/${this.$route.params.id}`, {
          status: 'revision',
          revision
        })
        this.$notify({ type: 'success', text: 'Revision sent!' })
        if (callback) callback()
        this.refreshData()
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    async handleApprove(callback) {
      const roleToStatusMap = {
        'Tech Mkt Support Manager': 'approved_by_tech_mkt_support_mgr',
        'Mkt & Sales GM': 'approved_by_mkt_sales_gm',
        'Mkt & Sales Dir': 'approved_by_sales_dir',
      }
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        const status = roleToStatusMap[this.currentRoleProgress]

        if (!status) throw new Error(`Unhandled role: ${this.currentRoleProgress}`)

        await axios.put(`/fnc-settlements/${this.$route.params.id}`, { status })
        this.$notify({ type: 'success', text: 'Feedback Approved!' })
        if (callback) callback()
        this.refreshData()
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    refreshData() {
      this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
      this.$store.dispatch('getDetailFeedbackComplaintSettlementIssue', this.$route.params.id)
    },
  },
  computed: {
    AppActiveUser() { return this.$store.state.AppActiveUser },
    detail() {
      return this.$store.state?.feedbackComplaint?.detail
    },
    settlementIssue() {
      return this.$store.state?.feedbackComplaint?.settlementIssue
    },
    currentRoleProgress() {
      const currentProgress = this.detail?.workflows.find(workflow => workflow?.status === 'on_progress')
      return currentProgress?.employee?.role ?? ''
    }
  },
}
</script>
